import {inject, Injectable} from '@angular/core';
import {PcRatingApiService} from "./pc-rating-api.service";
import {RecordsDataRequestQueryParams, RecordTableParams} from "../../../../../../../core/types/records-table.types";
import {CalculateWeeklyRatingParams, ProductCardRatingWeekly, WeeklyRating} from "../types/pc-rating-modal.types";


@Injectable({
  providedIn: 'root'
})
export class PcRatingService {
  private pcRatingApiService: PcRatingApiService = inject(PcRatingApiService);

  public getWeeklyRating(queryParams: RecordsDataRequestQueryParams): Promise<Array<ProductCardRatingWeekly>> {
    return new Promise((resolve, reject) => {
      this.pcRatingApiService.getWeeklyRating(queryParams).subscribe({
        next: (productCardRatings) => resolve(productCardRatings),
        error: (error) => reject(error)
      });
    });
  }

  public calculateWeeklyRating(calculateWeeklyRatingParams: CalculateWeeklyRatingParams): Promise<number> {
    return new Promise((resolve, reject) => {
      this.pcRatingApiService.calculateWeeklyRating(calculateWeeklyRatingParams).subscribe({
        next: (result) => resolve(result),
        error: (error) => reject(error)
      });
    });
  }

  public getMeta(): Promise<RecordTableParams> {
    return new Promise((resolve, reject) => {
      this.pcRatingApiService.getMeta().subscribe({
        next: (result) => resolve(result),
        error: (error) => reject(error)
      })
    })
  }

  public setQueryParams(productCardId: number): RecordsDataRequestQueryParams {
    return {
      page: 0,
      size: undefined,
      sort: [],
      'productCard.id': productCardId
    };
  }

  public normalizeRatingData(ratingData: Array<ProductCardRatingWeekly>): Array<ProductCardRatingWeekly> {
    if (!ratingData.length) { return ratingData; }

    const referenceDates = this.getReferenceDates(ratingData);
    ratingData.forEach(item => {
      for (let i = 0; i < referenceDates.length; i++) {
        const existingIndex = item.weeklyRatings.findIndex(wr => wr.dateFrom === referenceDates[i]);
        if (existingIndex === -1) {
          item.weeklyRatings.splice(i, 0, { dateFrom: referenceDates[i], dateTo: '' } as WeeklyRating);
        }
      }
    });

    return ratingData;
  }

  private getReferenceDates(ratingData: Array<ProductCardRatingWeekly>): Array<string> {
    const maxItem = ratingData.reduce((max, item) =>
      item.weeklyRatings.length > max.weeklyRatings.length ? item : max
    );

    return maxItem.weeklyRatings
      .map(wr => wr.dateFrom)
      .sort();
  }
}
